




































































































import {Vue, Component} from 'vue-property-decorator';
import {CertificationInfo} from 'supporter';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

const requiresCalendarCategoryNo = {
  broadEquipCertificate: 8, // 방송통신기자재 적합인증
  broadEquipRegistration: 9, // 방송통신기자재 적합등록
  broadEquipDate: 10, // 방송통신기자재 잠정인증일
}

interface Certification {
  certificationCategoryNo: number,
  text1: string,
  text2?: string,
  text3?: string,
  text4?: string,
}

@Component({
  components: { DateCalendar }
})
export default class CertificationAddForm extends Vue {
  private symbolList: string[] = ['\\', '*', '?', '"', '<', '>'];
  private saved = false;
  private categoryNo = '';
  private callback = '';
  private readonly isJsonInfo = this.$route.query.parentDutyInfoId === 'judgement_certificationJsonInfo' ? true : false;
  private certificationInfos: CertificationInfo[] = [];
  private certifications: Certification[] = [
    {
      certificationCategoryNo: 0,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
    },
    {
      certificationCategoryNo: 0,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
    },
    {
      certificationCategoryNo: 0,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
    },
    {
      certificationCategoryNo: 0,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
    },
    {
      certificationCategoryNo: 0,
      text1: '',
      text2: '',
      text3: '',
      text4: '',
    }
  ];

  private isRequiresCompanyCertificationCategory(certificateNo: number) {
    const requireCompany = this.certificationInfos.find((item) => item.certificationNo === certificateNo);
    return requireCompany ? requireCompany.requiresCompanyCertification : false;
  }

  private isRequiresCalendar(certificateNo: number) {
    /**
     * 22.12.22 현재 파트너(프로와 같음)와 프리미엄의 인증정보를 부모 컴포넌트로 전달하는 로직이 완전 다릅니다.
     * 만약 리펙토링시 파트너,프로의 동작을 따라하는게 좋을것같습니다.(김동욱)
     * */

    const arr = Object.values(requiresCalendarCategoryNo);
    let flag = false;

    for(let item of arr) {
      if(item === certificateNo) {
        flag = true;
      }
    }

    return flag;
  }

  private getCalendarOption(id: number) {
    return {
      dateType: 'Ymd',
      name: `calendar_${id}`,
      fromRanges: '1900-01-01',
      toRanges: '2999-12-31',
      placeholder: 'PRODUCT_CERTIFICATION_DATE_CHOOSE',
      endDate: false,
    }
  }

  created() {
    if (this.$route.query.hasOwnProperty('categoryNo')) {
      this.categoryNo = this.$route.query.categoryNo as string;
    }
    this.$api
      .getCertificationInfos({
        params: {
          standardCategoryNo: Number(this.categoryNo)
        }
      })
      .then((ret) => {
        this.certificationInfos = ret.data;
      });
    if (this.$route.query.hasOwnProperty('dataCallback')) {
      this.callback = this.$route.query.dataCallback as string;
    }

    if (this.$route.query.hasOwnProperty('data')) {
      const data = JSON.parse(this.$route.query.data as string);

      data.forEach(({certificationContents, certificationCategoryNo}: {certificationContents: string[], certificationCategoryNo: number}, index: number) => {
        this.certifications[index].certificationCategoryNo = certificationCategoryNo;

        if (certificationContents.length === 1) {
          this.certifications[index].text1 = certificationContents[0];
        }
        if (certificationContents.length === 2) {
          this.certifications[index].text1 = certificationContents[0];
          this.certifications[index].text2 = certificationContents[1];
        }
        if (certificationContents.length === 3) {
          this.certifications[index].text1 = certificationContents[0];
          this.certifications[index].text2 = certificationContents[1];
          this.certifications[index].text3 = certificationContents[2];
        }
        if (certificationContents.length === 4) {
          this.certifications[index].text1 = certificationContents[0];
          this.certifications[index].text2 = certificationContents[1];
          this.certifications[index].text3 = certificationContents[2];
          this.certifications[index].text4 = certificationContents[3];
        }
      });
      this.$forceUpdate();
    }
  }

  private addCertification() {
    if (this.certifications.length === 20) {
      alert(window.$t('PRODUCT_CERTIFICATION_CERTIFICATION_20'));
    } else {
      this.certifications.push({
        certificationCategoryNo: 0,
        text1: '',
        text2: '',
        text3: '',
        text4: '',
      });
    }
  }

  private deleteCertification(index: number) {
    this.certifications.splice(index, 1);
  }

  private changeCertCategory(certCategoryNo: number, index: number) {
    if (certCategoryNo) {
      const findedCertfication = this.certifications.find((item: any, i: number) => {
        return index !== i && item.certificationCategoryNo === certCategoryNo;
      });

      if (findedCertfication) {
        this.certifications[index].certificationCategoryNo = 0;
        alert(window.$t('PRODUCT_CERTIFICATION_SAME'));
      }
    }
  }

  private save() {
    this.saved = true;
    let validationFlag = {
      isInput: true,
      isDate: true,
    };

    this.certifications.forEach((item: any) => {
      if (item.certificationCategoryNo) {
        const isText3 = this.isRequiresCompanyCertificationCategory(item.certificationCategoryNo); // text3이 필요한지
        const isText4 = this.isRequiresCalendar(item.certificationCategoryNo); // text4가 필요한지

        if(!item.text1 || !item.text2 || (isText3 && !item.text3)) {
          validationFlag.isInput = false;
          return;
        }

        if(isText4 && !item.text4) {
          validationFlag.isDate = false;
          return;
        }
      }
    });

    if(!validationFlag.isInput) {
      alert(window.$t('PRODUCT_CERTIFICATION_MUST_ITEM'));
      return;
    }
    
    if(!validationFlag.isDate) {
      alert(window.$t('PRODUCT_CERTIFICATION_MUST_DATE'));
      return;
    }

    const data: any[] = [];
    let certificationContents = [];

    this.certifications.forEach((item: any) => {
      if (item.certificationCategoryNo) {
        if(this.isRequiresCalendar(item.certificationCategoryNo)) {
          certificationContents = [item.text1, item.text2, item.text3, item.text4];
        } else if(this.isRequiresCompanyCertificationCategory(item.certificationCategoryNo)) {
          certificationContents = [item.text1, item.text2, item.text3];
        } else {
          certificationContents = [item.text1, item.text2];
        }

        data.push({
          certificationCategoryNo: item.certificationCategoryNo,
          certificationContents: certificationContents
        });
      }
    });

    $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(data)});`);
    window.close();
  }

  validation(e: Event) {
    let value = (e.target as HTMLInputElement).value;
    let validateResult= true
    this.symbolList.forEach((str: string) => {
      if (value.includes(str)&&validateResult) {
        validateResult = false
        alert(`${window.$t('PRODUCT_CERTIFICATION_NEXT_PROHIBIT')}\r\n(${this.symbolList.join(' ')})`);
      }
      value = value.replace(str, '');
    });
    (e.target as HTMLInputElement).value = value;
  }
}
